import { render } from "./ViewAccount.vue?vue&type=template&id=e61acbbc&scoped=true&ts=true"
import script from "./ViewAccount.vue?vue&type=script&lang=ts"
export * from "./ViewAccount.vue?vue&type=script&lang=ts"

import "./ViewAccount.vue?vue&type=style&index=0&id=e61acbbc&lang=scss&scoped=true"

import exportComponent from "/builds/Chirbou/isolation/client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e61acbbc"]])

export default __exports__